const bankBranchLength = (value) => {
  if (!value) {
    return false;
  }
  return value.length === 4;
};
export default bankBranchLength;
